export const DirectDebit = {
    allowed: [
        'AT',
        'BE',
        'DE',
        'DK',
        'ES',
        'FI',
        'FR',
        'LU',
        'NL',
        'PT',
        'SE',
        'EE',
        'GR',
        'IE',
        'IT',
        'HR',
        'LV',
        'LT',
        'MT',
        'PL',
        'RO',
        'SK',
        'SI',
        'CZ',
        'HU',
        'CY',
    ]
};
